export default {
    /**
     * Get list initial state
     * @returns {{ byId: any, data: any[], item: any }}
     */
    list: () => ({ byId: {}, data: [], item: null }),
};
